import React from "react"
import types from "prop-types"
import { Button } from "shared/buttons"

const AddWhitelistedUserEmailDescButton = ({ onClick }) => (
  <Button
    className="border border-light-300 text-focus"
    text="+ Add Whitelist Entry"
    onClick={onClick}
  />
)

AddWhitelistedUserEmailDescButton.propTypes = {
  onClick: types.func.isRequired,
}

export default AddWhitelistedUserEmailDescButton
